// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.puzzles-item-actions {\n    display: flex !important;\n}\n.puzzles-image-my:hover .puzzles-image-original {\n    display: block;\n}\n.puzzles-image-original {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
